import React from "react"
import ThemePlaceholder from "components/Common/ThemePlaceholder"

/**
 * fields: [{ label: string, value: string }]
 * loading: boolean
 */
export const prepareDataWithLoading = (fields = [], loading = false) => {
  if (loading) {
    return fields.map(field => ({
      label: field.label,
      value: (
        <ThemePlaceholder
          style={{
            width: field.width || `${Math.min(Math.max(field.label.length * 10, 50), 150)}px`,
            height: 20,
            borderRadius: 4,
          }}
        />
      ),
    }))
  }

  return fields.map(field => ({
    label: field.label,
    value: field.value || "-",
  }))
}
